<script>
import {Locale} from "vue-i18n";
import LocalStorage from "@/libs/Storage";

export default {
  emits: ["onSwitchLanguage"],
  props: {
    propId: String,
    propLocale: Locale
  },
  watch: {
    propLocale(newData, oldData) {
      this.setCurrentLocale(newData);
    },
  },
  data() {
    return {
      currentLocale: this.$i18n.locale
    }
  },
  methods: {
    setCurrentLocale(locale) {
      this.currentLocale = locale; // Update current locale state
      this.$emit('onSwitchLanguage', locale);
    },
    switchLanguage(locale) {
      this.$i18n.locale = locale;

      //Store selected language locally in browser
      LocalStorage.set('lang', locale);
    }
  }
}

</script>

<template>
  <!-- The active flag image, changing based on the selected language -->
  <a class="nav-link dropdown-toggle m-0"
     :id="propId"
     role="button"
     data-bs-toggle="dropdown"
     aria-expanded="false">
    <!-- Show the flag based on the current active language -->
    <img
        :src="currentLocale === 'en' ? require('@/assets/img/flags/en.png') : require('@/assets/img/flags/it.png')"
        height="20"
        width="20"
        :alt="currentLocale === 'en' ? 'English' : 'Italian'"
    />
  </a>
  <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown" style="min-width: auto;">
    <li v-if="currentLocale === 'en'">
      <a class="dropdown-item pointer_cursor" @click="switchLanguage('it')">
        <img src="../assets/img/flags/it.png" height="20" width="20" alt="Italian"/>
      </a>
    </li>
    <li v-if="currentLocale === 'it'">
      <a class="dropdown-item pointer_cursor" @click="switchLanguage('en')">
        <img src="../assets/img/flags/en.png" height="20" width="20" alt="English"/>
      </a>
    </li>
  </ul>
</template>
